import * as React from "react";
import { useCpFormValue } from "./utils";
import { CpFormItem } from "./CpFormItem";
import { CpLabel } from "./CpLabel";
import { CpErrorWarning } from "./CpErrorWarning";
import { CpTextArea } from "./CpTextArea";

interface Props {
  namePath: string;
  descriptionPath: string;
}
export const CpInputDescription: React.FC<Props> = ({ namePath, descriptionPath }) => {
  const name = useCpFormValue(namePath);

  return (
    <CpFormItem>
      <CpLabel name={descriptionPath}>Description</CpLabel>
      <CpTextArea autoSize name={descriptionPath} placeholder={name} style={{ maxWidth: 600 }} />
      <CpErrorWarning name={descriptionPath} />
    </CpFormItem>
  );
};
